import { render, staticRenderFns } from "./GenerateContentDoc.vue?vue&type=template&id=65a263cb&scoped=true"
import script from "./GenerateContentDoc.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateContentDoc.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GenerateContentDoc.vue?vue&type=style&index=0&id=65a263cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a263cb",
  null
  
)

export default component.exports